import { EditorView } from 'prosemirror-view';

import { TableCell, TableRow } from '@lyearn/lygo-blocks';

import { PerformanceType } from '../ExtensionManager/types';
import { nodePerformanceMapKey } from '../Plugin/nodePerformanceMapPlugin';

const isBlockBasedNode = (nodePerformanceTypeMap: any) => (childDesc: any) =>
  nodePerformanceTypeMap.get(childDesc?.node?.type.name) === PerformanceType.BLOCK_BASED;

const isExtraBlock = (childDesc: any) => {
  const tableRowNode = new TableRow();
  const tableCellNode = new TableCell();
  return (
    [tableRowNode.name, tableCellNode.name].includes(childDesc?.node?.type.name) &&
    childDesc.children.length === 0
  );
};

const getPMLeafNodeViewDesc = (
  proseMirrorRootNode: Node,
  breakCondition?: (childDesc: any) => boolean,
) => {
  // @ts-ignore
  const children = [...proseMirrorRootNode.pmViewDesc.children];
  const pmLeafNodeViewDesc = [];
  let key = 0;
  while (key < children.length) {
    const childDesc = children[key];
    if (
      childDesc.node &&
      ((childDesc.node.isLeaf && !childDesc.node.isText) || // Atom type nodes
        childDesc.node.isTextblock) // Text Block Nodes
    ) {
      pmLeafNodeViewDesc.push(childDesc);
    }
    if (breakCondition?.(childDesc)) {
      //add block to pmLeafNodeViewDesc  arr if ignored due to leaf/atom condition above
      if (
        childDesc.node &&
        !(childDesc.node.isLeaf && !childDesc.node.isText) && // not Atom type nodes
        !childDesc.node.isTextblock // not Text Block Nodes
      ) {
        pmLeafNodeViewDesc.push(childDesc);
      }
    } else {
      children.push(...childDesc.children);
    }
    key++;
  }

  return pmLeafNodeViewDesc;
};

const getNodePerformanceMap = (view: EditorView) => {
  return nodePerformanceMapKey.getState(view.state).nodePerformanceMap;
};

const getPerformanceTypeNodes = (
  view: EditorView,
  performanceType: PerformanceType,
  breakCondition?: (childDesc: any) => boolean,
) => {
  const proseMirrorRootNode = view.domAtPos(0);
  const nodePerformanceMap = getNodePerformanceMap(view);

  return getPMLeafNodeViewDesc(proseMirrorRootNode.node, breakCondition).filter(
    (childDesc) => nodePerformanceMap.get(childDesc.node?.type.name) === performanceType,
  );
};

export const getBlockIds = (view?: EditorView, performanceType?: PerformanceType) => {
  // @ts-ignore
  if (!view?.docView || !performanceType) {
    return [];
  }

  const nodePerformanceMap = getNodePerformanceMap(view);

  return getPerformanceTypeNodes(view, performanceType, isBlockBasedNode(nodePerformanceMap)).map(
    (child) => child.node?.attrs.id,
  );
};

// Use this function to get the map between leaf PM nodes and corresponding DOM element.
// Use that DOM element to get the boundingClientRect so that we don't need to re-run the
// PM leaf node traversal logic.
const getPMNodeDOMMap = (view?: EditorView) => {
  // @ts-ignore
  if (!view?.docView) {
    return null;
  }

  if (view) {
    const proseMirrorNodeClientRect = new Map();
    getPerformanceTypeNodes(view, PerformanceType.SCROLL_BASED, isExtraBlock).every((childDesc) =>
      proseMirrorNodeClientRect.set(childDesc.node, childDesc.dom),
    );

    return proseMirrorNodeClientRect;
  }

  console.error(
    '[getPMNodeClientRect] DOM element with the class ProseMirror or Editorview not found',
  );

  return null;
};

export default getPMNodeDOMMap;
export { NodePerformanceContext, useNodePerformanceContext } from './PerfromanceProvider';
